import { Link } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { MdKeyboardArrowRight } from "react-icons/md";
import { usePayroll } from "../../../hooks/usePayroll";
import './FolhaPrevia.css'
import { Select } from "../../select";
import { useEffect, useState } from "react";
import moment from "moment";
import { formatValueToMonetary } from "../../../utils/formatter";
import ReactModal from "react-modal";
import { Box } from "../../box";
import { PageHeader } from "../../page-header";

export default function () {
  const { user } = useAuth()
  const { payrolls, listPayrolls, getDetailedPayroll, detailedPayroll, generatePayroll, createPayroll, lockPayroll, loading, getHolerite, sendHoletireByEmail } = usePayroll();
  const [avaliableMonths, setAvaliableMonths] = useState([]);
  const [selectedPayroll, setSelectedPayroll] = useState();
  const [isCreatingPayroll, setIsCreatingPayroll] = useState(false);
  const [collaboratorsToExclude, setCollaboratorsToExclude] = useState([]);

  const getTotalNetAmount = () => {
    const total = detailedPayroll?.items.reduce((acc, item) => acc + item.netAmount, 0);
    return formatValueToMonetary(total);
  }

  const getTotalGrossAmount = () => {
    const total = detailedPayroll?.items.reduce((acc, item) => acc + item.grossAmount, 0);
    return formatValueToMonetary(total);
  }

  const getTotalDiscountsAmount = () => {
    const total = detailedPayroll?.items.reduce((acc, item) => acc + item.discountAmount, 0);
    return formatValueToMonetary(total);
  }

  const handleCreatePayroll = async (referenceDate) => {
    await createPayroll({
      referenceMonth: moment(referenceDate).month() + 1,
      referenceYear: moment(referenceDate).year(),
    });
  }

  const openCreatePayrollModal = () => {
    setIsCreatingPayroll(true);
  }

  const handleGeneratePayroll = async (payrollId) => {
    await generatePayroll(payrollId, collaboratorsToExclude);
    getDetailedPayroll(payrollId);
    setCollaboratorsToExclude([]);
  }

  const handleLockPayroll = async (payrollId) => {
    await lockPayroll(payrollId);
    getDetailedPayroll(payrollId);
  }

  const handleSendHoletireByEmail = async (payrollItemSnapshotId) => {
    await sendHoletireByEmail(payrollItemSnapshotId);
  }

  const mapStatusToLabel = (status) => {
    const map = {
      DRAFT: 'PRÉVIA ABERTA',
      CALCULATED: 'PRÉVIA CALCULADA',
      SCHEDULED: 'FOLHA AGENDADA',
      LOCKED: 'FOLHA TRAVADA',
      PAID: 'FOLHA PAGA',
    };

    return map[status] || status;
  }

  useEffect(() => {
    listPayrolls();
  }, [])

  useEffect(() => {
    if (payrolls && payrolls.length > 0) {
      setAvaliableMonths(payrolls.map(p => {
        return {
          value: p.id,
          label: moment(`${p.referenceYear}-${p.referenceMonth}`).format('MMMM / YYYY')
        }
      }));
      setSelectedPayroll(payrolls[0].id);
    }
  }, [payrolls])

  useEffect(() => {
    if (!selectedPayroll) return;

    const payroll = payrolls?.find(p => p.id === selectedPayroll);
    getDetailedPayroll(payroll?.id);
  }, [selectedPayroll])

  const handleToggleCollaborator = (collaboratorId) => {
    setCollaboratorsToExclude((prev) => {
      if (prev.includes(collaboratorId)) {
        return prev.filter(id => id !== collaboratorId);
      }

      return [...prev, collaboratorId];
    });
  };

  return (
    <div className="preview-container">
      <div className="col-md-10">
        <div className="mt-4 mb-3">
          <PageHeader title="Prévia de folha" pages={[{ name: 'Prévia de folha', link: "/folha-pagamento/dashboard" }]} />
        </div>
        <section id="screen-preview" className="screen active screen-preview">
          <p className="subtitle">Revise os valores antes de fechar a folha e enviar para pagamento. Envie também o comprovante de pagamento para o e-mail do colaborador. </p>
          
          {payrolls && payrolls.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="empty-state-title">Nenhuma folha de pagamento encontrada</h3>
              <p className="empty-state-description">
                Comece criando sua primeira folha de pagamento para gerenciar os salários e pagamentos dos colaboradores.
              </p>
              <button className="empty-state-button" onClick={openCreatePayrollModal}>
                + Nova Folha
              </button>
            </div>
          ) : (
            <>
              <div className="filters-row payroll-actions-row">
                {/* Lado esquerdo: contexto */}
                <div className="payroll-context">
                  <Select
                    options={avaliableMonths}
                    value={selectedPayroll}
                    onChange={setSelectedPayroll}
                    disabled={loading}
                  />

                  <button
                    className="payroll-link-action"
                    onClick={openCreatePayrollModal.bind(this)}
                    disabled={loading}
                  >
                    + Nova folha
                  </button>

                  {detailedPayroll && detailedPayroll.payroll?.status === "CALCULATED" && (
                    <button
                      className="payroll-link-action"
                      onClick={handleGeneratePayroll.bind(this, detailedPayroll.payroll?.id)}
                      disabled={loading}
                    >
                      ↻ Recalcular folha
                    </button>
                  )}
                </div>

                {/* Lado direito: ação principal */}
                <div className="payroll-primary-action">
                  {detailedPayroll && detailedPayroll.payroll?.status === "DRAFT" && (
                    <button
                      className="payroll-primary-button"
                      onClick={handleGeneratePayroll.bind(this, detailedPayroll.payroll?.id)}
                      disabled={loading}
                    >
                      {loading ? "Gerando..." : "Fechar prévia e gerar folha"}
                    </button>
                  )}

                  {detailedPayroll && detailedPayroll.payroll?.status === "CALCULATED" && (
                    <button
                      className="payroll-primary-button"
                      onClick={handleLockPayroll.bind(this, detailedPayroll.payroll?.id)}
                      disabled={loading}
                    >
                      {loading ? "Enviando..." : "Enviar para pagamento"}
                    </button>
                  )}

                  <div className="pill">{mapStatusToLabel(detailedPayroll?.payroll?.status)}</div>
                  {
                    detailedPayroll?.payroll?.status === "PAID" &&
                    <a className="payroll-link-action" href={`/folha-pagamento/pagamento/${detailedPayroll?.payroll?.id}/status`}>Ver Pagamentos</a>
                  }
                </div>
              </div>

              <div className="cards-row">
                <div className="preview-card">
                  <div className="card-title">Total bruto</div>
                  <div className="card-value">{getTotalGrossAmount()}</div>
                  <div className="card-footnote">Inclui salários e proventos.</div>
                </div>
                <div className="preview-card">
                  <div className="card-title">Descontos</div>
                  <div className="card-value">{getTotalDiscountsAmount()}</div>
                  <div className="card-footnote">INSS, IRRF, VT, VR, convênios e outros.</div>
                </div>
                <div className="preview-card">
                  <div className="card-title">Líquido a pagar</div>
                  <div className="card-value">{getTotalNetAmount()}</div>
                  <div className="card-footnote">Total aos colaboradores / PJs.</div>
                </div>
                {/* <div className="preview-card">
              <div className="card-title">Encargos do empregador</div>
              <div className="card-value">R$ 158.900,
                00</div>
              <div className="card-footnote">INSS patronal,
                FGTS e terceiros.</div>
            </div> */}
              </div>
              <div className="preview-collaborator-table-content">
                <table className="preview-collaborator-table">
                  <thead>
                    <tr>
                      <th>Colaborador</th>
                      <th>Vínculo</th>
                      <th>Base</th>
                      <th>Descontos</th>
                      <th>Líquido</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      detailedPayroll?.items?.map(c => {
                        return (
                          <tr key={c.id}>
                            <td>{c.collaborator?.name}</td>
                            <td>{c.collaborator?.employmentType}</td>
                            <td>{formatValueToMonetary(c.grossAmount)}</td>
                            <td>{formatValueToMonetary(c.discountAmount)}</td>
                            <td>{formatValueToMonetary(c.netAmount)}</td>
                            <td><span className="status-ok">Ativo</span></td>
                            <td className="payroll-actions-cell">
                              {
                                ["PAID"].includes(detailedPayroll?.payroll?.status) ?

                                  <>
                                    <a role="button" className="payroll-action-link" onClick={() => loading ? null : getHolerite(c.snapshotId)}>
                                      {
                                        loading ? "Baixando..." : "Baixar holerite"
                                      }
                                    </a>

                                    <button className="payroll-secondary-action" onClick={() => loading ? null : handleSendHoletireByEmail(c.snapshotId)}>
                                      {
                                        loading ? "Enviando..." : "Enviar comprovante por e-mail"
                                      }
                                    </button>
                                  </>
                                  :
                                  <span> - </span>
                              }
                            </td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
              </div>
            </>
          )}
        </section>
      </div>

      <ReactModal
        isOpen={isCreatingPayroll}
        className={'payroll-modal'}
        overlayClassName={'overlay-payroll-modal'}
        onRequestClose={() => setIsCreatingPayroll(false)}
        ariaHideApp={false}
      >
        <Box
          title={"Criar nova folha de pagamento"}
          description={"Selecione o mês e o ano de referência para a nova folha de pagamento."}
          key={"payroll-modal"}
        >
          <div className="col-md-12">
            <label className="font-semibold text-sm">Mês de referência</label>
            <input
              type="month"
              className="form-control"
              min={moment().subtract(1, 'year').format('YYYY-MM')}
              max={moment().format('YYYY-MM')}
              defaultValue={moment().format('YYYY-MM')}
              id="referenceMonthInput"
            />
            <div className="d-flex justify-content-between mt-4">
              <button
                className="payroll-primary-button"
                onClick={async () => {
                  const referenceDate = document.getElementById('referenceMonthInput').value;
                  await handleCreatePayroll(referenceDate);
                  setIsCreatingPayroll(false);
                }}
              >
                {loading ? "Criando..." : "Criar folha"}
              </button>
              <button
                className="payroll-secondary-action"
                onClick={() => setIsCreatingPayroll(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </Box>
      </ReactModal>
    </div>
  );
}
